<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div
      class="modal fade"
      id="modal_form_producto_export"
      style="background-color: #00000082"
    >
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <h4 class="modal-title text-white">Generar listado Productos</h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              id="close-modal"
              ref="closeModal1"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link active"
                  id="tab-Columnas"
                  data-toggle="tab"
                  href="#Columnas"
                  >Columnas</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="tab-Filtros"
                  data-toggle="tab"
                  href="#Filtros"
                  >Filtros
                </a>
              </li>
            </ul>
            <div class="tab-content" id="myTabContent">
              <div class="tab-pane" id="Filtros">
                <div class="card-body">
                  <div class="form-group row">
                    <label for="nombre" class="col-md-5">Producto</label>
                    <input
                      type="text"
                      id="nombre"
                      v-model="filtros.nombre"
                      class="col-md-7"
                    />
                  </div>
                  <div class="form-group row">
                    <label for="linea_negocio_id" class="col-md-5"
                      >Linea de Negocio</label
                    >
                    <select
                      class="form-control form-control-sm col-md-7"
                      v-model="filtros.linea_negocio_id"
                    >
                      <option value="">Seleccione...</option>
                      <option
                        v-for="linea_negocio_id in listasForms.lineas_negocio"
                        :key="linea_negocio_id.id"
                        :value="linea_negocio_id.id"
                      >
                        {{ linea_negocio_id.nombre }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group row">
                    <label for="tipo_producto" class="col-md-5">
                      Mercancía Transportada</label
                    >
                    <select
                      id="tipo_producto"
                      class="form-control form-control-sm col-md-7"
                      v-model="filtros.tipo_producto"
                    >
                      <option value="">Seleccione...</option>
                      <option
                        v-for="tipo_producto in listasForms.tipos_producto"
                        :key="tipo_producto.numeracion"
                        :value="tipo_producto.numeracion"
                      >
                        {{ tipo_producto.descripcion }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group row">
                    <label for="unidad_medida" class="col-md-5"
                      >Unidad de Medida</label
                    >
                    <select
                      id="unidad_medida"
                      class="form-control form-control-sm col-md-7"
                      v-model="filtros.unidad_medida"
                    >
                      <option value="">Seleccione...</option>
                      <option
                        v-for="unidad_medida in listasForms.unidades_medidas"
                        :key="unidad_medida.numeracion"
                        :value="unidad_medida.numeracion"
                      >
                        {{ unidad_medida.descripcion }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group row">
                    <label for="tolerancia_perdidas" class="col-md-5"
                      >Tolerancia a perdidas</label
                    >
                    <input
                      type="number"
                      id="tolerancia_perdidas"
                      v-model="filtros.tolerancia_perdidas"
                      class="col-md-7"
                    />
                  </div>
                </div>
              </div>
              <div class="tab-pane fade active show" id="Columnas">
                <div class="card-body">
                  <div class="row">
                    <div class="col-lg-11">
                      <div class="form-group">
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="nombre1"
                              v-model="form.nombre"
                              class="custom-control-input"
                            />
                            <label class="custom-control-label" for="nombre1"
                              >Nombre</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="linea_negocio_id1"
                              v-model="form.linea_negocio_id"
                              class="custom-control-input"
                            />
                            <label
                              class="custom-control-label"
                              for="linea_negocio_id1"
                              >Línea de Negocio</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="tipo_producto1"
                              v-model="form.tipo_producto"
                              class="custom-control-input"
                            />
                            <label
                              class="custom-control-label"
                              for="tipo_producto1"
                              >Mercancía transportada</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="unidad_medida1"
                              v-model="form.unidad_medida"
                              class="custom-control-input"
                            />
                            <label
                              class="custom-control-label"
                              for="unidad_medida1"
                              >Unidad de Medida</label
                            >
                          </div>
                        </div>
                        <div class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            id="tolerancia_perdidas1"
                            v-model="form.tolerancia_perdidas"
                            class="custom-control-input"
                          />
                          <label class="custom-control-label" for="tolerancia_perdidas1"
                            >Tolerancia a perdidas</label
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer justify-content-between">
            <div>
              <button
                type="button"
                class="btn btn-sm bg-navy"
                @click="generarListadoExcel()"
                v-if="$store.getters.can('admin.productos.export')"
              >
                Generar Listado
                <i class="fas fa-file-download"> </i>
              </button>
            </div>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
//import vSelect from "vue-select";
import Loading from "../../../../components/Loading";
export default {
  name: "ProductoExport", //llegada tambien
  components: {
    Loading,
    //vSelect
  },
  data() {
    return {
      cargando: false,
      form: {
        nombre: true,
        linea_negocio_id: true,
        tipo_producto: true,
        unidad_medida: true,
        tolerancia_perdidas: true,
      },
      filtros: {
        nombre: null,
        linea_negocio_id: null,
        tipo_producto: null,
        unidad_medida: null,
        tolerancia_perdidas: null,
      },

      listasForms: {
        lineas_negocio: [],
        tipos_producto: [],
        unidades_medidas: [],
        tolerancia_perdidas: [],
      },
    };
  },

  methods: {
    async getLineasNegocio() {
      await axios.get("/api/admin/lineasNegocios/lista").then((response) => {
        this.listasForms.lineas_negocio = response.data;
      });
    },
    getTipoProductos() {
      axios.get("/api/lista/7").then((response) => {
        this.listasForms.tipos_producto = response.data;
      });
    },

    getUnidadesMedidas() {
      axios.get("/api/lista/8").then((response) => {
        this.listasForms.unidades_medidas = response.data;
      });
    },

    generarListadoExcel() {
      this.cargando = true;
      axios({
        method: "POST",
        url: "/api/admin/productos/export",
        data: { form: this.form, filtros: this.filtros },
      })
        .then((response) => {
          let data = response.data;
          this.cargando = false;
          location.href = data.url;
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title: "Ocurrio un error" + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.cargando = false;
        });
    },
  },

  async mounted() {
    this.cargando = true;
    await this.getTipoProductos();
    await this.getUnidadesMedidas();
    await this.getLineasNegocio();
    this.cargando = false;
  },
};
</script>
